/* eslint-disable import/prefer-default-export */
import { schema } from 'normalizr';

const sprintsListSchema = [new schema.Entity('items')];

export {
  sprintsListSchema,
};
